<!-- eslint-disable vue/no-v-html -->
<template>
  <div v-if="dataIsLoad" id="info-sidebar" class="product-info">
    <div class="product-fav">
      <h1 class="product-name">
        {{ itemDatas.Name }}
      </h1>
      <div class="item-wish">
        <a class="btn-wish" @click.prevent="toggleFavorite(selectedData.IsFavorite)">
          <i v-if="selectedData.IsFavorite" class="icon-wish-active" />
          <i v-else class="icon-wish" />
        </a>
      </div>
    </div>
    <h3 class="product-subtitle">{{ itemDatas.SubTitle }}</h3>
    <h3 class="product-price">
      <span class="sell-price"> NT.{{ mapSellPrice.toLocaleString() }} </span>
      <span
        v-if="itemDatas.EventPrice > 0 || itemDatas.SellPrice !== itemDatas.OriginPrice"
        class="origin-price"
      >
        NT.{{ itemDatas.OriginPrice.toLocaleString() }}
      </span>
    </h3>
    <div v-if="allSpecPreOrder" class="product-arrival">
      {{ itemDatas.ArrivalExplanation }}
    </div>
    <div
      v-if="!allSpecPreOrder && selectedSpec !== null && selectedSpec.PreOrder"
      class="product-arrival"
    >
      {{ itemDatas.ArrivalExplanation }}
    </div>
    <div class="product-color-wrap">
      <div>
        <div
          v-for="color in itemDatas.Colors"
          :key="color.ID"
          class="product-color"
          :class="{ active: color.ID === selectedData.ID }"
          @click.prevent="changeImg(color.ID)"
        >
          <img :src="color.PintSizePictureUrl" />
        </div>
      </div>
      <div class="selected-color">{{ selectedData.Name }}</div>
    </div>
    <div class="d-none d-lg-flex product-select-container">
      <div class="size-selector">
        <Selector
          :options="selectedData.Specs"
          :default-txt="'尺寸'"
          :selected="selectedSpec"
          @cb="selectSpec"
        />
      </div>
      <div class="count-selector">
        <Quantity
          v-model="counter"
          :default-txt="'數量'"
          :reduce-count="() => reduceCount()"
          :add-count="
            () =>
              addCount({
                maxCount: selectedSpec.Stock,
                limit: itemDatas.Limit,
              })
          "
        />
      </div>
    </div>
    <a
      class="d-none d-lg-block mt-3 btn btn-add-cart"
      :class="btnStyleGenerate"
      @click.prevent="clickToCart"
    >
      {{ btnDescriptionGenerate }}
    </a>
    <div v-if="mapEvents" class="product-event">
      <div v-if="itemDatas.Limit !== 0" class="py-1">此商品限購 {{ itemDatas.Limit }} 件</div>
      <div v-for="(event, index) in itemDatas.Events" :key="index" class="py-1">
        <a :href="'/campaign/' + event.ID">{{ event.Name }}</a>
      </div>
      <div v-for="(giftEvent, index) in itemDatas.GiftEvents" :key="index" class="py-1">
        <a :href="'/campaign/gift/' + giftEvent.ID">{{ giftEvent.Name }}</a>
      </div>
    </div>
    <ul class="list-collapse">
      <li>
        <a
          class="collapsed"
          data-toggle="collapse"
          href="#collapseDescription"
          role="button"
          aria-expanded="false"
          aria-controls="collapseDescription"
        >
          <span class="text-en">商品資訊</span>
        </a>
        <div id="collapseDescription" class="collapse">
          <div class="py-3">
            <div class="mb-2" v-html="itemDatas.Description" />
            <div class="mb-3" v-html="itemDatas.MaterialDescription" />
            <p>產地: {{ itemDatas.MaterialOriginDescription }}</p>
            <p>加工產地: {{ itemDatas.OriginDescription }}</p>
            <div class="product-barcode mb-2">{{ selectedSpec.Barcode }}</div>
          </div>
        </div>
      </li>
      <li>
        <a
          class="collapsed"
          data-toggle="collapse"
          href="#collapseWash"
          role="button"
          aria-expanded="false"
          aria-controls="collapseWash"
        >
          <span class="text-en">洗滌方式</span>
        </a>
        <div id="collapseWash" class="collapse">
          <div class="py-3">
            <div class="mb-2" v-html="itemDatas.CareLabelDesc" />
          </div>
        </div>
      </li>
      <li>
        <a class="collapsed" href="#" @click.prevent="showSizeChart">
          <span class="text-en">尺寸指南</span>
        </a>
      </li>
    </ul>
    <div v-if="dataIsLoad" id="bottom-bar" class="d-lg-none">
      <!-- 此按鈕只顯示兩種狀態 -->
      <a
        href="#"
        :class="itemDatas.IsPreShow ? 'btn-secondary disabled' : ''"
        class="open-dialog btn-add-cart btn"
        @click.prevent="showMobileCartDialog"
      >
        {{ itemDatas.IsPreShow ? 'COMING SOON' : '加入購物車' }}
      </a>
    </div>
    <!-- 加價購桌機 -->
    <div class="d-none d-lg-block">
      <AddonShop :market-id="CustomMarketID.substring(0, CustomMarketID.indexOf('CL'))" />
    </div>
    <!-- 手機板選單跳窗 -->
    <SpecMobile />
  </div>
</template>

<script setup>
import $ from 'jquery';
import { computed, watch, nextTick } from 'vue';
import { storeToRefs } from 'pinia';

import Selector from '@components/Select.vue';
import Quantity from '@components/Quantity.vue';
import SpecMobile from '@page/shopContent/components/SpecMobile.vue';
import AddonShop from '@page/shopContent/components/AddonShop.vue';

import useModalStore from '@global/stores/useModalStore';
import useShopContentStore from '@global/stores/useShopContentStore';

import useMsg from '@global/composable/useMessage';
import useAlert from '@global/composable/useAlert';

const { CustomMarketID } = window;
const { messageBox } = useMsg();
const { alertDialog } = useAlert();

const modalStore = useModalStore();
const { openModal } = modalStore;

const shopContentStore = useShopContentStore();
const {
  selectedData,
  itemDatas,
  dataIsLoad,
  selectedSpec,
  counter,
  allSpecPreOrder,
  btnStyleGenerate,
  btnDescriptionGenerate,
  CMID,
} = storeToRefs(shopContentStore);
const {
  addCount,
  reduceCount,
  showMobileCartDialog,
  addToCart,
  selectSpec,
  changeImg,
  toggleFavorite,
} = shopContentStore;

const mapEvents = computed(() => {
  return (
    itemDatas.value.Events?.length !== 0 ||
    itemDatas.value.GiftEvents?.length !== 0 ||
    itemDatas.value.Limit !== 0
  );
});

const mapSellPrice = computed(() => {
  return itemDatas.value.EventPrice > 0 && itemDatas.value.EventPrice < itemDatas.value.SellPrice
    ? itemDatas.value.EventPrice
    : itemDatas.value.SellPrice;
});

watch(dataIsLoad, (isLoad) => {
  if (isLoad && window.matchMedia('(min-width: 992px)').matches) {
    nextTick(() => {
      $('#info-sidebar').stick_in_parent({ offset_top: 179 });
    });
  }
});
async function clickToCart() {
  try {
    const resolve = await addToCart();
    if (resolve === undefined) return;
    const { code } = resolve;

    switch (code) {
      case 200:
        messageBox.cart('加入購物車');
        break;
      case 205:
        alertDialog.alert('商品已售完', () => {
          window.location.reload();
        });
        break;
      default:
        break;
    }
  } catch (error) {
    console.log(error);
  }
}

function showSizeChart() {
  openModal('SizeModal', itemDatas.value);
}
</script>
